export default __webpack_public_path__ + "static/media/powerball_banner_highlight.8c254b3f.png";